import CryptoJS from 'crypto-js'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'

const { getStorageData } = SessionStorageUtils()

// 이메일을 핀으로 암호화
const CreateVerifyPin = (pin: string, email: string) => {
  const hash = CryptoJS.SHA256(pin).toString()
  const cipher = CryptoJS.AES.encrypt(email, CryptoJS.enc.Hex.parse(hash), {
    iv: CryptoJS.enc.Utf8.parse('B!y P^es$si1mo3n'),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })
  return {
    hash: hash,
    cipher: cipher.toString(),
  }
}

// 핀을 이메일로 암호화
const ResetVerifyPin = (pin: string, email: string) => {
  const hash = CryptoJS.SHA256(email).toString()
  const cipher = CryptoJS.AES.encrypt(pin, CryptoJS.enc.Hex.parse(hash), {
    iv: CryptoJS.enc.Utf8.parse('B!y P^es$si1mo3n'),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })
  return cipher.toString()
}

const getUniqueKey = () => {
  const pinHash = getStorageData('userInfo').pinHash
  const Pin = getStorageData('pin').Pin

  const decrypt = CryptoJS.AES.decrypt(Pin, CryptoJS.enc.Hex.parse(pinHash), {
    iv: CryptoJS.enc.Utf8.parse('B!y P^es$si1mo3n'),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })

  return decrypt.toString(CryptoJS.enc.Utf8)
}

const DecryptData = (data: string) => {
  try {
    if (!data) return ''

    const uniqueKey = getUniqueKey()
    const hash = CryptoJS.SHA256(uniqueKey).toString()

    const dataDecrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Hex.parse(hash), {
      iv: CryptoJS.enc.Utf8.parse('B!y P^es$si1mo3n'),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    })
    if (!dataDecrypted) return ''

    return dataDecrypted.toString(CryptoJS?.enc?.Utf8) === 'null'
      ? ''
      : dataDecrypted.toString(CryptoJS?.enc?.Utf8)
  } catch (error) {
    console.error('복호화 오류', error)
    return ''
  }
}

//복호화 검증용
const decryptionVerify = () => {
  const userInfo = getStorageData('userInfo')
  const { VerifyPin, pinHash, Email } = userInfo

  const decrypt = CryptoJS.AES.decrypt(VerifyPin, CryptoJS.enc.Hex.parse(pinHash), {
    iv: CryptoJS.enc.Utf8.parse('B!y P^es$si1mo3n'),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })
  return decrypt.toString(CryptoJS.enc.Utf8) === Email
}

export const CryptoUtils = { CreateVerifyPin, ResetVerifyPin, DecryptData, decryptionVerify }
